import PropTypes from 'prop-types';
export const calculatorSubscribePropTypes = {
  icon: PropTypes.string,
  heading: PropTypes.string,
  placeholder: PropTypes.string,
  button: PropTypes.shape({
    label: PropTypes.string,
    classname: PropTypes.string,
    icon: PropTypes.string
  }),
  handleSubmit: PropTypes.func,
  infoMsg: PropTypes.string,
  errorMsg: PropTypes.string
};